<div
  [ngClass]="{ finished: isTask && isTaskFinished, untouched: isTask && isTaskUntouched, placeholder: isPlaceholder }"
  class="communication-item {{ item.communicationType }}">
  <div class="item-badge-container">
    <div class="badge">{{ initials }}</div>
  </div>
  <div class="item-text-container flex-1">
    <span [innerHTML]="text" class="message"></span>

    @if (task.processSteps?.length) {
      <div class="item-process-container">
        @for (process of task.processSteps; track process) {
          <div class="process">
            <div>
              <span>{{ "communication.task.processStep." + process.stepType | translate }}</span>
              @if (process?.finishedBy) {
                <span class="finished">By {{ process.finishedBy?.fullName }} on {{ process.finishedAt | date: "d MMM y h:mm" }}</span>
              }
            </div>
            <div [ngClass]="{ done: process.isFinished }" class="bubble"></div>
          </div>
        }
      </div>
    }

    <span class="date">{{ item.createdAt | date: "MMMM d, y, h:mm" }}</span>
  </div>

  <div class="item-action-container">
    @if (false) {
      <button>
        <fa-icon [icon]="['fas', 'ellipsis-h']"></fa-icon>
      </button>
    }
    @if (item.isNew) {
      <div class="item-unread"></div>
    }
  </div>
</div>
